











import Vue from "vue";
import DocumentToolbarAction from "@/components/modules/document/toolbar/DocumentToolbarAction.vue";
import Shared from "@/shared";
export default Vue.extend({
    name: "GoToDocumentManagementAction",
    components: { DocumentToolbarAction },
    props: {
        documentId: String,
        version: Number,
        enable: { default: true },
        isButton: Boolean
    },
    methods: {
        goToDocumentManagement(): void {
            const path = `${Shared.iProvaUrl}/iDocument/management/documents/details/view/document_details.aspx?documentid=${this.documentId}&versionnumber=${this.version}`;
            window.open(path);
        }
    }
});
